import "./sprinkles.css.ts.vanilla.css-mistica.js";
var o = "_1y2v1nfdm";
export { o as boxBorder };
